export default {
  options: {
    true: 'Sí',
    false: 'No',
  },
};
